import { RouterProvider } from 'react-router-dom';
import { router } from 'src/sensors/router';
import { memo, Suspense, useContext, useMemo } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import { SkeletonMainLayout } from './modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout';
import { RuntimeContext } from './runtimeContext';
import { useScreenSize } from './modules/common/hooks/useScreenSize';
import { MOBILE_WIDTH } from './modules/common/constants';

export const AppSensors = memo(() => {
    const { userSettings } = useContext(ConfigContext);
    const composeRouter = router();

    const collator = useMemo(() => {
        const language = userSettings.currentLocale.substring(0, 2);

        return new Intl.Collator(language);
    }, [userSettings.currentLocale]);

    const { width } = useScreenSize();
    const value = useMemo(() => ({
        isMobile: width < MOBILE_WIDTH,
        collator,
    }), [width, collator]);

    return (
        <RuntimeContext.Provider value={value}>
            <Suspense fallback={<SkeletonMainLayout/>}>
                <RouterProvider router={composeRouter}/>
            </Suspense>
        </RuntimeContext.Provider>
    );
});
